import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ServiceEntryPopup from './ServiceEntryPopup';
import {
  getActiveServiceEntryPopup,
  isPopupClosedForSession,
  isPopupDismissedForWeek,
  isPopupRouteAllowed,
  markPopupClosedForSession,
  markPopupDismissedForWeek,
} from '../../services/popupService';
import { PopupBanner } from '../../types';

const PopupManager: React.FC = () => {
  const location = useLocation();
  const [popup, setPopup] = useState<PopupBanner | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadPopup = async () => {
      if (!isPopupRouteAllowed(location.pathname)) {
        setIsVisible(false);
        return;
      }

      try {
        const activePopup = await getActiveServiceEntryPopup();
        if (cancelled || !activePopup) {
          if (!cancelled) {
            setPopup(null);
            setIsVisible(false);
          }
          return;
        }

        const dismissed = isPopupDismissedForWeek(activePopup);
        const closedForSession = isPopupClosedForSession(activePopup);
        if (dismissed || closedForSession) {
          setPopup(activePopup);
          setIsVisible(false);
          return;
        }

        setPopup(activePopup);
        setIsVisible(true);
      } catch (error) {
        console.error('서비스 진입 팝업 조회 실패:', error);
        if (!cancelled) {
          setPopup(null);
          setIsVisible(false);
        }
      }
    };

    void loadPopup();

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  const handleClose = () => {
    if (!popup) return;
    markPopupClosedForSession(popup);
    setIsVisible(false);
  };

  const handleCloseForWeek = () => {
    if (!popup) return;
    markPopupDismissedForWeek(popup);
    setIsVisible(false);
  };

  if (!popup) {
    return null;
  }

  return (
    <ServiceEntryPopup
      popup={popup}
      isOpen={isVisible}
      onClose={handleClose}
      onCloseForWeek={handleCloseForWeek}
    />
  );
};

export default PopupManager;
